import { WebSocketReliabilityManager } from './websocket-reliability-manager';
import { HttpReliabilityManager } from './http-reliability-manager';
import { HttpWorker } from './http-worker';
export const createConnectionReliabilityManager = (worker, rateControllerClose, clientMetadata, sessionCorrelationVector, reducedPingPongRetryEnabled) => {
    if (worker instanceof HttpWorker) {
        return new HttpReliabilityManager(worker, clientMetadata, sessionCorrelationVector);
    }
    else {
        return new WebSocketReliabilityManager(worker, rateControllerClose, clientMetadata, reducedPingPongRetryEnabled);
    }
};
//# sourceMappingURL=iconnection-reliability-manager.js.map